import { FAKE, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'

export const GOOGLE_PLACES_API = Symbol('GOOGLE_PLACES_API')

export class GoogleAutocompletePlacesRequest {
  endpointUrl: URL
  method = 'GET' as const
  headers: HeadersInit = {
    Accept: 'application/json',
    RequestMode: 'no-cors'
  }
  controller: AbortController = new AbortController()

  constructor(searchTerm: string, apiKey: string, proxy: string, country: string | null) {
    this.endpointUrl = new URL(proxy, window.location.href)

    const proxyUrl = new URL('https://maps.googleapis.com/maps/api/place/autocomplete/json')
    proxyUrl.searchParams.set('input', searchTerm)
    proxyUrl.searchParams.set('key', apiKey)

    if (country) {
      proxyUrl.searchParams.set('region', country)
    }

    this.endpointUrl.searchParams.set('url', proxyUrl.toString())
  }
}

@registerDependency(FAKE, GOOGLE_PLACES_API)
export class FakeGoogleAutocompleteAPI {

  autocompleteResults: unknown
  requests: GoogleAutocompletePlacesRequest[] = []

  searchPlaces = (request: GoogleAutocompletePlacesRequest) => {
    this.requests.push(request)
    return Promise.resolve(this.autocompleteResults)
  }
}

@registerDependency(REAL, GOOGLE_PLACES_API)
export class GooglePlacesApi {

  searchPlaces = async (request: GoogleAutocompletePlacesRequest): Promise<unknown> => {
    return await fetch(request.endpointUrl, {
      headers: request.headers,
      method: request.method,
    }).then(r => r.json())
  }
}
